var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect, _rect2, _rect3, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenericError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 80,
    viewBox: "0 0 84 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.68751 79.7288H35.5188C36.0655 79.7288 36.5088 79.2855 36.5088 78.7388V49.7606C36.5144 49.4909 36.4098 49.2305 36.219 49.0397C36.0282 48.849 35.7679 48.7443 35.4981 48.75H21.5075L19.5825 46.8319L17.6644 48.75H3.68751C3.14231 48.7538 2.70126 49.1948 2.69751 49.74V78.7181C2.69384 78.9837 2.79631 79.2398 2.98217 79.4295C3.16803 79.6192 3.42192 79.7269 3.68751 79.7288Z",
    fill: "#AEB2B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3138 79.5087H82.145C82.6891 79.505 83.1281 79.0628 83.1281 78.5187V49.5406C83.1281 48.9965 82.6891 48.5544 82.145 48.5506H68.1475L66.25 46.6325L64.325 48.5506H50.3138C49.767 48.5506 49.3238 48.9939 49.3238 49.5406V78.5187C49.3238 79.0655 49.767 79.5087 50.3138 79.5087Z",
    fill: "#AEB2B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0725 2.52937H27.2412C26.9793 2.52936 26.7282 2.63388 26.5436 2.81974C26.359 3.00561 26.2563 3.25744 26.2581 3.51937V32.4906C26.2563 32.7525 26.359 33.0044 26.5436 33.1902C26.7282 33.3761 26.9793 33.4806 27.2412 33.4806H41.2387L43.1569 35.3987L45.0819 33.4806H59.0725C59.3356 33.4825 59.5885 33.3788 59.7746 33.1927C59.9606 33.0066 60.0643 32.7537 60.0625 32.4906V3.51937C60.0643 3.25624 59.9606 3.00336 59.7746 2.81729C59.5885 2.63123 59.3356 2.52752 59.0725 2.52937Z",
    fill: "#AEB2B8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.59375 39.7231H82.7569H0.59375Z",
    fill: "#ADB0B5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.59375 39.7231H82.7569",
    stroke: "#231F20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7338 42.1225C43.0589 42.1225 44.1331 41.0483 44.1331 39.7231C44.1331 38.398 43.0589 37.3237 41.7338 37.3237C40.4086 37.3237 39.3344 38.398 39.3344 39.7231C39.3344 41.0483 40.4086 42.1225 41.7338 42.1225Z",
    fill: "#ADB0B5",
    stroke: "#231F20"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2762 42.1225C19.6014 42.1225 20.6756 41.0483 20.6756 39.7231C20.6756 38.398 19.6014 37.3237 18.2762 37.3237C16.9511 37.3237 15.8769 38.398 15.8769 39.7231C15.8769 41.0483 16.9511 42.1225 18.2762 42.1225Z",
    fill: "#EDEDED",
    stroke: "#231F20"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64.985 42.1225C66.3101 42.1225 67.3844 41.0483 67.3844 39.7231C67.3844 38.398 66.3101 37.3237 64.985 37.3237C63.6599 37.3237 62.5856 38.398 62.5856 39.7231C62.5856 41.0483 63.6599 42.1225 64.985 42.1225Z",
    fill: "#EDEDED",
    stroke: "#231F20"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6494 0.968744H25.8181C25.555 0.966897 25.3021 1.07061 25.116 1.25667C24.93 1.44273 24.8263 1.69562 24.8281 1.95874V30.93C24.8263 31.1931 24.93 31.446 25.116 31.6321C25.3021 31.8181 25.555 31.9218 25.8181 31.92H39.8087L41.7337 33.845L43.6519 31.92H57.6494C58.1961 31.92 58.6394 31.4768 58.6394 30.93V1.95874C58.6394 1.41198 58.1961 0.968744 57.6494 0.968744Z",
    fill: "white",
    stroke: "#231F20"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34.9413,
    y: 15.1519,
    width: 2.85313,
    height: 10.725,
    fill: "#EDEDED",
    stroke: "#231F20"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40.3037,
    y: 10.7312,
    width: 2.85313,
    height: 15.1456,
    fill: "#ADB0B5",
    stroke: "#231F20"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 45.6663,
    y: 6.02187,
    width: 2.85313,
    height: 19.855,
    fill: "#EDEDED",
    stroke: "#231F20"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2.56 78.4844H34.3912C34.938 78.4844 35.3812 78.0411 35.3812 77.4944V48.5162C35.3812 47.9695 34.938 47.5262 34.3912 47.5262H20.4006L18.4756 45.6081L16.5575 47.5262H2.56C2.01592 47.53 1.57686 47.9722 1.57687 48.5162V77.4944C1.57686 78.0385 2.01592 78.4806 2.56 78.4844Z",
    fill: "#EDEDED",
    stroke: "#231F20"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8469 57.5294L19.9262 59.7087C20.0172 59.8994 20.1982 60.0312 20.4075 60.0594L22.8137 60.41C23.0562 60.4433 23.2585 60.6121 23.3345 60.8447C23.4106 61.0773 23.3472 61.333 23.1712 61.5031L21.4319 63.1875C21.2859 63.3392 21.2175 63.5495 21.2462 63.7581L21.6587 66.1575C21.7025 66.4002 21.6042 66.6466 21.4056 66.7927C21.2069 66.9388 20.9424 66.9591 20.7237 66.845L18.5719 65.7106C18.3829 65.6194 18.1627 65.6194 17.9737 65.7106L15.8219 66.845C15.6041 66.9611 15.3389 66.9415 15.1406 66.7945C14.9422 66.6476 14.8462 66.3997 14.8937 66.1575L15.2994 63.7581C15.3391 63.55 15.272 63.3358 15.1206 63.1875L13.3744 61.4894C13.222 61.3175 13.1736 61.077 13.2475 60.8596C13.3214 60.6421 13.5063 60.481 13.7319 60.4375L16.1381 60.0869C16.3474 60.0587 16.5284 59.9269 16.6194 59.7362L17.6987 57.5569C17.8008 57.3351 18.0202 57.1909 18.2642 57.185C18.5083 57.1792 18.7343 57.3128 18.8469 57.5294Z",
    fill: "#ADB0B5",
    stroke: "#231F20"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2756 78.4844H81.1069C81.6521 78.4806 82.0931 78.0396 82.0969 77.4944V48.5162C82.0931 47.971 81.6521 47.53 81.1069 47.5262H67.1094L65.1913 45.6081L63.2731 47.5262H49.2756C48.7289 47.5262 48.2856 47.9695 48.2856 48.5162V77.4944C48.2856 78.0411 48.7289 78.4844 49.2756 78.4844Z",
    fill: "#EDEDED",
    stroke: "#231F20"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0094 71.5544L63.3144 62.72L67.3844 64.645L76.865 53.8856V71.5544H55.0094Z",
    fill: "#ADB0B5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0094 71.5544L63.3144 62.72L67.3844 64.645L76.865 53.8856",
    stroke: "#231F20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenericError);
export default __webpack_public_path__ + "static/media/generic-error.d316d3b5f4a9d66d99b2da374198c7d6.svg";
export { ForwardRef as ReactComponent };